import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';

import queryString from 'query-string';

import AdjustPrompt from 'components/admin/AdjustPrompt';
import { ActionsDropdownForItem } from 'components/base/ActionsDropdown';
import { ADJUST_TYPES, CUSTOMER_DETAIL_TAB_NAME } from 'config/CustomEnums';
import { PermissionCodes } from 'config/PermissionCodes';
import BaseListContainer from 'containers/base/BaseListContainer';
import BaseTabListContainer from 'containers/base/BaseTabListContainer';

import CustomerCampaignListFilter from './CustomerCampaignListFilter';

import { getHashKeyString } from 'utils';

function CustomerStampCampaignList({
  listFields,
  dataList,
  pageInfo,
  totalPage,
  totalCount,
  setAdjustPrompt,
}) {
  const dispatch = useDispatch();
  const location = useLocation();
  const hash = getHashKeyString(location.hash);
  const params = useParams();
  const customerId = params.id;

  useEffect(() => {
    if (hash !== CUSTOMER_DETAIL_TAB_NAME.stampCampaign) {
      return;
    };
    dispatch({
      type: 'campaignCategoryList/getCampaignCategoryList',
      payload: { isAll: true, nameContainsId: true },
    })
  }, [dispatch, hash])

  useEffect(() => {
    if (hash !== CUSTOMER_DETAIL_TAB_NAME.stampCampaign) {
      return;
    }
    const parsedSearch = queryString.parse(location.search);
    const searchKey = parsedSearch['search'] || '';
    const stringPage = parsedSearch['page'] || 1;
    const page = parseInt(stringPage);
    const categoryList = parsedSearch['categories'] || '';

    dispatch({
      type: 'campaignList/getCustomerDetailCampaignList',
      payload: {
        page,
        customerId,
        searchKey,
        categoryList,
        isStamp: true,
      },
    });
  }, [dispatch, location]);

  return (
    <>
      <BaseTabListContainer
        hideTab={true}
        maxTabWidth={670}
        groupActions={[]}
        pageInfo={pageInfo}
        totalCount={totalCount}
        filter={{ hasFilter: true, component: CustomerCampaignListFilter }}
        listContent={
          <BaseListContainer
            fields={listFields}
            dataList={dataList}
            totalPage={totalPage}
            model={'campaignList'}
            permissionGroup={PermissionCodes.campaign}
            deleteInfo={{
              data: [],
              title: 'Campaigns',
              relatedName: '',
              onComfirm: {},
              relatedSections: null,
            }}
            useCustomCommonActions={true}
            customCommonActions={(item) => {
              const actions = [];
              const totalStampsEarned = item.totalStampsEarned || 0
              const maxRequiredStamps = item.maxRequiredStamps || 0
              if (totalStampsEarned < maxRequiredStamps) {
                actions.push({
                  name: 'Add stamp',
                  action: (item) => {
                    setAdjustPrompt({
                      show: true,
                      adjustType: ADJUST_TYPES.stamp,
                      prefillData: {
                        purpose: 'Add',
                        targetCampaign: item,
                      },
                    });
                  },
                  requires: PermissionCodes.adjustAllRewards,
                });
              }
              if (totalStampsEarned) {
                actions.push({
                  name: 'Remove stamp',
                  action: (item) => {
                    setAdjustPrompt({
                      show: true,
                      adjustType: ADJUST_TYPES.stamp,
                      prefillData: {
                        purpose: 'Remove',
                        targetCampaign: item,
                      },
                    });
                  },
                  requires: PermissionCodes.adjustAllRewards,
                });
              }

              return (
                <ActionsDropdownForItem
                  object={item}
                  actions={actions}
                  otherActions={[]}
                />
              );
            }}
            openNewTab
            customPathname="/stamp_campaigns"
          />
        }
      />
    </>
  );
}

const mapPropsToState = (state) => ({
  listFields: state.campaignList.customerDetailStampListFields,
  dataList: state.campaignList.pagedList,
  pageInfo: state.campaignList.pageInfo,
  totalPage: state.campaignList.totalPage,
  totalCount: state.campaignList.totalCount,
});

export default connect(mapPropsToState)(CustomerStampCampaignList);
